// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".productsList{display:flex;flex-wrap:wrap}.productsList__item{flex:0 0 100%;max-width:100%}.productsList__empty{margin:2rem 0 0;width:100%}@media(max-width:768px){.productsList__empty{padding:0 2rem}}.productsList__empty .infoBar__inner{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
